interface Props {
  readonly tag?: string;
  readonly children: any;
}

export function WidgetText(props: Props | any) {
  const Tag = props.tag || 'p';

  const customProps = {
    ...props,
  };

  delete customProps.tag;

  if (!props.children) return null;

  return <Tag {...(customProps as any)} />;
}
